module.exports = __webpack_public_path__ + "img/btn_kakao.6728322c.png";